// map = {
//     name: {
//         loginType: ...,
//         options: [
//             ......
//         ]
//     }
// }

var authUtil = {

    _map: {},
    tmpLoginType: null,
    tmpName: null,

    // 新增 loginType, 一個字串
    login: function(loginType) {
        if(!loginType) {
            throw new Error('無效的 loginType: ' + loginType );
        }
        this.tmpLoginType = loginType;
        this.tmpName = null;
        return this;
    },
    // 新增 name 至 map 的 key, 一個陣列或字串
    name: function(name) {
        if(!name) {
            throw new Error('無效的 name: ' + name );
        } else if(!this.tmpLoginType) {
            throw new Error('錯誤的 name: ' + name + ', 請先定義 login 方式');
        } else if(this._map[name]) {
            throw new Error('無效的 name: ' + name + ', 重複定義');
        }

        doAll(name, (name) => {
            this._map[name] = {
                loginType: this.tmpLoginType,
                options: []
            }
        });
        
        this.tmpName = name;
        return this;
    },
    // 新增 name 下的 options, 一個物件
    option: function(option) {

        if(!option) {
            throw new Error('無效的 option: ' + option );
        } else if(!this.tmpLoginType ) {
            throw new Error('錯誤的 option: ' + option + ', 請先定義 login 方式 與 name');
        } else if ( !this.tmpName ) {
            throw new Error('錯誤的 option: ' + option + ', 請先定義 name');
        }
        doAll(this.tmpName, (name) => {
            this._map[name].options.push(option);
        });

        return this;
    },

    getAuthMap: function() {
        return this._map;
    },

    setSessionStorage: function(params) {
        sessionStorage.setItem(params.loginType, jsonCompile(params.option));
    },
    // 判斷身分為個人戶, 公司戶, 外國人
    getIdentity(pid) {
        let personalReg = /^[a-zA-Z]{1}\d{9}$/
        let companyReg = /^\d{8}$/
        if(!pid) {
            return null;
        }
        if(personalReg.test(pid)) {
            return 'personal'
        } else if(companyReg.test(pid)) {
            return 'company'
        } else {
            return 'foreigner'
        }
    }

}


const registerAuth = (Vue, authObj) => {
    var map = authObj && authObj.getAuthMap() || {};

    if (Vue ) {
        
        Vue.mixin({
            methods: {
                auth(name) {
                    let rule = map[name];
                    if(rule ) {

                        // 取得 sessionStorage 對應到的 name
                        let sessionOpts;
                        if(sessionStorage[rule.loginType] ) {
                            sessionOpts = jsonUncompile(sessionStorage[rule.loginType]);
                            if(!sessionOpts) {
                                return false;
                            }
                        } else {
                            return false;
                        }
                        // 若有 option, 對每個 option 作驗證，一個成功則 通過
                        let pass = true;
                        if(rule.options.length > 0) {
                            pass = rule.options.some(opt => {
                                // 取得 option 下所有值 與 sessionStorage.loginType 比對，若全部成功則 回傳 true
                                let allPass = Object.keys(opt).every(key => {
                                    return check(sessionOpts[key], opt[key] );
                                });
                                return allPass;
                            });
                        }
                        return pass;
                    } else {
                        console.warn('auth() 查無綁定 name: ', name);
                        return true;
                    }
                }
            }
        });

    }
}


// 判斷是否為陣列，若是， forEach doSth
function doAll(name, doSth) {

    if(name instanceof Array) {
        name.forEach(n => {
            doSth(n);
        });
    } else {
        doSth(name);
    }
}

function check(target, ref) {
    if(ref instanceof Array) {
        return ref.includes(target);
    } else {
        return ref == target;
    }
}




// 簡單加解密工具
function jsonCompile(code) {
    code = JSON.stringify(code);
    var c=String.fromCharCode(code.charCodeAt(0)+code.length + 47);  
    for(var i=1;i<code.length;i++){  
        c+=String.fromCharCode(code.charCodeAt(i)+code.charCodeAt(i-1)); 
    }  
    return escape(c);
}


function jsonUncompile(code)  {
    code=unescape(code);  
    var c=String.fromCharCode(code.charCodeAt(0)-code.length - 47);  
    for(var i=1;i<code.length;i++){  
        c+=String.fromCharCode(code.charCodeAt(i)-c.charCodeAt(i-1)); 
    }  
    return JSON.parse(c);
}


export {registerAuth, authUtil};


// const auth = registerAuth(Vue, 
//     [
//       {
//         loginType: 'cas',
//         rules: [
//           {
//             // CommonView/common(撥打國際電話、撥打付費電話、撥打行動交友簡碼)、靜態頁面做權限驗證(指定轉接、查詢語音信箱、多方通話、數據用量提醒
//             name: 'cas_4g',
//             options: {
//               productType: '4G'
//             }
//           },
//           // {
//           //   // CommonView/restriction(去化保密、語中插接)、開啟VoLTE
//           //   name: 'cas_4g_9',
//           //   options: {
//           //     productType: '4G',
//           //     contractStatus: '9'
//           //   }
//           // },
//           // {
//           //   // 快速復話
//           //   name: 'cas_4g_10',
//           //   options: {
//           //     productType: '4G',
//           //     contractStatus: '10'
//           //   }
//           // },
//           // {
//           //   // 國際漫遊
//           //   name: 'roaming',
//           //   options: {
//           //     productType: ['4G'],
//           //     contractStatus: '9'
//           //   }
//           // },
//           // {
//           //   name: 'test1',
//           //   options: {}
//           // },
//           // {
//           //   name: 'test1',
//           //   options: { }
//           // },
//           // {
//           //   name: 'test2',
//           //   options: {
//           //     contractStatus: '10'
//           //   }
//           // }
//         ]
//       },
//       // {
//       //   loginType: 'bid',
      //   rules: [
      //     {
      //       // bidLogin 購買快樂包
      //       name: 'bid_login',
      //       options: {
      //         productType: '4G',
      //         contractStatus: '9'
      //       }
      //     }
      //   ]
      // }
    // ]);


// WEBPACK FOOTER //
// ./src/util/plugins.js